__turbopack_context__.v({
  "Black": "_71ismW_Black",
  "Left": "_71ismW_Left",
  "MobileLeft": "_71ismW_MobileLeft",
  "Root": "_71ismW_Root",
  "Vertical": "_71ismW_Vertical",
});
